// extracted by mini-css-extract-plugin
export var notificationHost = "_kw-0";